import React, { useState } from 'react'
import { fetchReactionContentBlocks } from 'shared/api'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { giphyBlue } from '@giphy/js-brand'
import { IContentBlock } from './types'
import Blocks from './components/blocks'
import { ContentBlockContext } from './context'

type Props = {
    className?: string
    width?: number
}

const ReactionsContentBlocks = ({ className, width }: Props) => {
    const [blocks, setBlocks] = useState<IContentBlock[]>([])

    useAsyncEffect(async () => {
        const { results } = await fetchReactionContentBlocks()
        setBlocks(
            results
                .filter(({ is_private, featured_gif }) => !is_private && !!featured_gif)
                .map(({ id, user, featured_gif, url, display_name, slug }) => ({
                    id,
                    url,
                    user,
                    label: display_name || slug,
                    gif: featured_gif,
                }))
        )
    }, [])

    return (
        <ContentBlockContext.Provider
            value={{
                title: 'React With These',
                labelColor: giphyBlue,
                seeAllUrl: '/reactions',
                width,
            }}
        >
            <Blocks blocks={blocks} className={className} />
        </ContentBlockContext.Provider>
    )
}

export default ReactionsContentBlocks
